import React from 'react';

const Check: React.FC = () => (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M4.90623 7.79319L4.88862 7.81081L0.48877 3.41096L1.92145 1.97829L4.90629 4.96313L9.68031 0.189117L11.113 1.62179L4.92391 7.81087L4.90623 7.79319Z"
            fill="white"
        />
    </svg>
);

export default Check;
